import {useId} from "react";
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {SlotSlider} from "@pg-design/slot-slider-module";
import {Text} from "@pg-design/text-module";

import {PRICES_HUB_SHORTS, PRICES_HUB_SHORTS_CHANNEL_HREF, PRICES_HUB_SHORTS_CHANNEL_NAME} from "../../constants/prices_hub_shorts";
import {trackPricesHubButtonClick} from "../../tracking/track_prices_hub_button_click";
import {PricesHubShortsTile} from "./PricesHubShortsTile";
import {PricesHubViewSectionTracker} from "./PricesHubViewSectionTracker";

export const PricesHubShorts = () => {
    const headingId = useId();

    if (PRICES_HUB_SHORTS.length === 0) {
        return null;
    }

    return (
        <section className={sectionStyle} aria-labelledby={headingId}>
            <PricesHubViewSectionTracker sectionName="shorts" />

            <Container maxWidthVariant="lg">
                <SlotSlider
                    className={sliderStyle}
                    headerClassName={headerStyle}
                    listClassName={listStyle}
                    itemClassName={itemStyle}
                    listLabel="Krótkie filmy ekspertów o cenach mieszkań"
                    prevLabel="Poprzednie filmy"
                    nextLabel="Następne filmy"
                    onNavigate={(direction) => trackPricesHubButtonClick({buttonName: "rp_apartment_prices_shorts_arrow", value: direction})}
                    header={
                        <div className={headCopyStyle}>
                            <Text id={headingId} as="h2" variant="headline_3" className={headingStyle}>
                                Shorts – krótkie analizy cenowe ekspertów
                            </Text>

                            <a href={PRICES_HUB_SHORTS_CHANNEL_HREF} target="_blank" rel="noopener noreferrer" className={channelLinkStyle}>
                                <Text as="span" variant="info_txt_1">
                                    Kanał {PRICES_HUB_SHORTS_CHANNEL_NAME} na YouTube
                                </Text>
                            </a>
                        </div>
                    }
                >
                    {PRICES_HUB_SHORTS.map((short) => (
                        <PricesHubShortsTile key={short.videoId} short={short} />
                    ))}
                </SlotSlider>
            </Container>
        </section>
    );
};

const sectionStyle = css({
    py: 6,
    backgroundColor: "var(--colors-white)",

    md: {
        py: 8
    }
});

const sliderStyle = css({
    maxWidth: "127.2rem",
    mx: "auto",

    md: {
        gap: 3.5
    }
});

const headerStyle = css({
    gap: 1.5
});

const headCopyStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    minWidth: 0
});

const headingStyle = css({
    margin: 0,
    color: "var(--colors-secondary)"
});

const channelLinkStyle = css({
    alignSelf: "flex-start",
    color: "var(--colors-gray-700)",
    textDecoration: "none",

    _hover: {
        color: "var(--colors-secondary)",
        textDecoration: "underline"
    },

    _focusVisible: {
        outline: "2px solid var(--colors-secondary)",
        outlineOffset: "2px"
    }
});

const listStyle = css({
    gap: 1.5,

    md: {
        gap: 2
    }
});

const itemStyle = css({
    width: "15rem",

    md: {
        width: "16.4rem"
    }
});
import {useId} from "react";
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {SlotSlider} from "@pg-design/slot-slider-module";
import {Text} from "@pg-design/text-module";

import {PRICES_HUB_SHORTS, PRICES_HUB_SHORTS_CHANNEL_HREF, PRICES_HUB_SHORTS_CHANNEL_NAME} from "../../constants/prices_hub_shorts";
import {trackPricesHubButtonClick} from "../../tracking/track_prices_hub_button_click";
import {PricesHubShortsTile} from "./PricesHubShortsTile";
import {PricesHubViewSectionTracker} from "./PricesHubViewSectionTracker";

export const PricesHubShorts = () => {
    const headingId = useId();

    if (PRICES_HUB_SHORTS.length === 0) {
        return null;
    }

    return (
        <section className={sectionStyle} aria-labelledby={headingId}>
            <PricesHubViewSectionTracker sectionName="shorts" />

            <Container maxWidthVariant="lg">
                <SlotSlider
                    className={sliderStyle}
                    headerClassName={headerStyle}
                    listClassName={listStyle}
                    itemClassName={itemStyle}
                    listLabel="Krótkie filmy ekspertów o cenach mieszkań"
                    prevLabel="Poprzednie filmy"
                    nextLabel="Następne filmy"
                    onNavigate={(direction) => trackPricesHubButtonClick({buttonName: "rp_apartment_prices_shorts_arrow", value: direction})}
                    header={
                        <div className={headCopyStyle}>
                            <Text id={headingId} as="h2" variant="headline_3" className={headingStyle}>
                                Shorts – krótkie analizy cenowe ekspertów
                            </Text>

                            <a href={PRICES_HUB_SHORTS_CHANNEL_HREF} target="_blank" rel="noopener noreferrer" className={channelLinkStyle}>
                                <Text as="span" variant="info_txt_1">
                                    Kanał {PRICES_HUB_SHORTS_CHANNEL_NAME} na YouTube
                                </Text>
                            </a>
                        </div>
                    }
                >
                    {PRICES_HUB_SHORTS.map((short) => (
                        <PricesHubShortsTile key={short.videoId} short={short} />
                    ))}
                </SlotSlider>
            </Container>
        </section>
    );
};

const sectionStyle = css({
    py: 6,
    backgroundColor: "var(--colors-white)",

    md: {
        py: 8
    }
});

const sliderStyle = css({
    maxWidth: "127.2rem",
    mx: "auto",

    md: {
        gap: 3.5
    }
});

const headerStyle = css({
    gap: 1.5
});

const headCopyStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
    minWidth: 0
});

const headingStyle = css({
    margin: 0,
    color: "var(--colors-secondary)"
});

const channelLinkStyle = css({
    alignSelf: "flex-start",
    color: "var(--colors-gray-700)",
    textDecoration: "none",

    _hover: {
        color: "var(--colors-secondary)",
        textDecoration: "underline"
    },

    _focusVisible: {
        outline: "2px solid var(--colors-secondary)",
        outlineOffset: "2px"
    }
});

const listStyle = css({
    gap: 1.5,

    md: {
        gap: 2
    }
});

const itemStyle = css({
    width: "15rem",

    md: {
        width: "16.4rem"
    }
});
